import { Component, Input, ElementRef, ViewChild, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from '../services/icons.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { StatefulService } from '../services/stateful.service';

@Component({
  selector: 'app-sidebar',
  template: `
    <div class="main-nav nav-holder-for-fixed"></div>
      <div #sidebar id="sidebar" class="main-nav d-flex flex-column flex-shrink-0 p-3 d-none d-md-block fixed-top border border-0 bg-sidebar-dark" style="height: 101vh;">
        <div class="d-flex text-light bg-white py-2 px-3 rounded-4" *ngIf="roleLS?.group_id == 3">
          <div>
            <div class="rounded-5 bg-light avatar border border-1" style="width: 64px; height: 64px;">
              <!-- img src="{{avatarLS?.avatar}}" width="100%" -->
            </div>
          </div>
          <div class="flex-fill">
            <div class="ps-3 me-2 d-md-none d-lg-block username text-wrap" style="line-height: 1.2; margin-top: 15px;">
              <p class="mb-0 align-middle text-dark" style="font-size: 0.95em !important;">{{user.name}} {{user.last_name}}</p>
            </div>
          </div>
        </div>
        <div class="d-flex text-light bg-white py-2 px-3 rounded-4" *ngIf="profile">
          <div>
            <div class="rounded-5 bg-light avatar border border-1"  *ngIf="roleLS?.name != 'Administrativo'" style="width: 64px; height: 64px;">
              <img [src]="profile.logo" width="64" height="64" class="center-icon">              
            </div>
            <div class="rounded-5 bg-light avatar border border-1"  *ngIf="roleLS?.name === 'Administrativo'" style="width: 64px; height: 64px;">
              <img src="assets/images/logo-zazz.png" width="64" height="64" class="center-icon">
            </div>
          </div>
          <div class="flex-fill" *ngIf="roleLS?.name != 'Administrativo'">
            <div class="ps-3 me-2 d-md-none d-lg-block username text-wrap" style="line-height: 1.2; margin-top: 15px;">
              <p class="mb-0 align-middle text-dark" style="font-size: 0.75em !important;">{{profile.name}}</p>
              <h5 class="mb-0 text-muted" style="font-size: 12px;">Empresa</h5>
            </div>
          </div>
          <div class="flex-fill" *ngIf="roleLS?.name === 'Administrativo'">
            <div class="ps-3 me-2 d-md-none d-lg-block username text-wrap" style="line-height: 1.2; margin-top: 15px;">
              <p class="mb-0 align-middle text-dark" style="font-size: 0.75em !important;">Plataforma ZAZZ</p>
              <h5 class="mb-0 text-muted" style="font-size: 12px;"></h5>
            </div>
          </div>
          <div class="ms-auto text-end">            
            <div ngbDropdown class="d-inline-block mt-2" *ngIf="authService.hasPermission('can_read_companies')">
              <button type="button" class="btn btn-link btn-sm ps-0" id="dropdownBasic1" ngbDropdownToggle >
                <fa-icon [icon]="icons.faCaretDown" class="icon text-primary" size="1x" class="p-2 text-dark"></fa-icon>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1" >
                <button ngbDropdownItem *ngIf="authService.hasPermission('can_read_companies')">Ver perfiles</button>
                <button ngbDropdownItem *ngIf="authService.hasPermission('can_create_companies')">Crear perfil</button>
                <hr *ngIf="authService.hasPermission('can_create_companies')">
                <button ngbDropdownItem *ngFor="let profile of profiles" (click)="changeProfile(profile)">{{profile?.name}}</button>
              </div>
            </div>
          </div>
        </div>
        <ul class="nav nav-pills flex-column mb-auto mt-3" *ngIf="roleLS?.group_id != 3">
          <li class="nav-item mt-0">
            <ul #sidebar class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li> <!-- *ngIf="authService.hasPermission('can_read_dashboard')" -->
                <a #dashboard routerLink="dashboard" class="nav-link zazz-link link-light d-flex active" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-reports.svg" width="18px">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Resumen general</span>
                  </div>
                </a>
              </li>
              <li *ngIf="authService.hasPermission('can_read_settlements')">
                <a #clients routerLink="condominios/{{userLS.settlement_id}}" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-building.png" class="float-start" style="width: 20px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Condominios y comercial</span>
                  </div>
                </a>
              </li>
              <li *ngIf="authService.hasPermission('can_read_fuel')">
                <a #tanques routerLink="combustibles/tanques" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-gas.svg" class="float-start" style="width: 18px;"> 
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Combustible</span>
                  </div>
                </a>
              </li>
              <li *ngIf="authService.hasPermission('can_read_tasks')">
                <a #tasks routerLink="maintenances/tasks" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-tasks.svg" class="float-start" style="width: 20px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Tareas y Técnicos</span>
                  </div>
                </a>
              </li>
              <li *ngIf="authService.hasPermission('can_read_reports')">
                <a #reports routerLink="reports" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-reports.svg" class="float-start" style="width: 20px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Reportes y consumos</span>
                  </div>
                </a>
              </li> 
              <li *ngIf="authService.hasPermission('can_read_bills')">
                <a class="nav-link zazz-link link-light d-flex collapsed" 
                [attr.aria-expanded]="!isCollapsedP" aria-controls="collapseExample" (click)="navigate($event,'invoiceCollapse')">
                  <div>
                    <img src="assets/images/icon-invoices.svg" class="float-start" style="width: 18px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Facturación y recibos</span>
                  </div>
                </a>
                <div class="collapsable collapse" #invoiceCollapse id="invoiceCollapse" [ngbCollapse]="isCollapsedP">
                  <ul class="list-unstyled fw-normal small ms-4">
                    <li *ngIf="authService.hasPermission('can_read_invoices')">
                      <a routerLink="/invoices" class="nav-link zazz-link link-light clearfix pt-3 pb-0"> 
                        <span class="mt-0 pb-2 float-start">Facturación</span>
                      </a>
                    </li>
                    <li *ngIf="authService.hasPermission('can_read_bills')">
                      <a routerLink="/pagos" class="nav-link zazz-link link-light clearfix py-1">
                        <span class="mt-0 pb-2 float-start">Recibos</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <!-- li *ngIf="authService.hasPermission('can_read_users')">
                <a routerLink="reports" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-admin.svg" class="float-start" style="width: 20px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Administración</span>
                  </div>
                </a>
              </li --> 
              <li *ngIf="authService.hasPermission('can_read_roles')">
                <a routerLink="users" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-profiles.svg" class="float-start" style="width: 20px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Perfiles y roles</span>
                  </div>
                </a>
              </li> 

              <li *ngIf="authService.hasPermission('can_read_stock')">
                <a routerLink="/inventory" class="nav-link zazz-link link-light d-flex" (click)="navigate($event)">
                  <div>
                    <img src="assets/images/icon-dashboard.png" class="float-start" style="width: 20px;">
                  </div>
                  <div class="flex-fill">
                    <span class="mt-0 ms-3">Inventario</span>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="nav nav-pills flex-column mb-auto" *ngIf="roleLS?.group_id == 3">
          <li class="nav-item mt-0 mt-sm-5">
            <div class="collapse show" id="home-tenant">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li *ngIf="authService.hasPermission('can_read_users')">
                  <a routerLink="tenant/dashboard" class="nav-link zazz-link link-light clearfix">
                    <span class="mt-0 pb-2 ms-4 d-md-none d-lg-block float-start">Inicio</span>
                  </a>
                </li>
                <li *ngIf="authService.hasPermission('can_read_users')">
                  <a routerLink="tenant/profile/{{user.id}}" class="nav-link zazz-link link-light clearfix">
                    <span class="mt-0 pb-2 ms-4 d-md-none d-lg-block float-start">Mi perfil</span>
                  </a>
                </li>
                <li *ngIf="authService.hasPermission('can_read_payments')">
                  <a routerLink="tenant/payment-methods/{{user.id}}" class="nav-link zazz-link link-light clearfix">
                    <span class="mt-0 pb-2 ms-4 d-md-none d-lg-block float-start">Métodos de pago</span>
                  </a>
                </li>
                <li *ngIf="authService.hasPermission('can_read_payments')">
                  <a routerLink="tenant/bills/{{user.id}}" class="nav-link zazz-link link-light clearfix">
                    <span class="mt-0 pb-2 ms-4 d-md-none d-lg-block float-start">Mis recibos</span>
                  </a>
                </li>
                <li *ngIf="authService.hasPermission('can_read_payments')">
                  <a routerLink="tenant/payments/{{user.id}}" class="nav-link zazz-link link-light clearfix">
                    <span class="mt-0 pb-2 ms-4 d-md-none d-lg-block float-start">Historial de pagos</span>
                  </a>
                </li>
                <!-- li *ngIf="authService.hasPermission('can_read_invoices')">
                  <a routerLink="tenant/invoice/list/{{user.id}}" class="nav-link zazz-link link-light clearfix">
                    <span class="mt-0 pb-2 ms-4 d-md-none d-lg-block float-start">Mis facturas</span>
                  </a>
                </li -->
              </ul>
            </div>
          </li>
        </ul>
        <li class="nav-item text-secondary list-unstyled fixed-bottom px-3">
          <div class="d-flex bg-light rounded-4 mb-3 py-3">
            <div class="flex-fill text-center">
              <fa-icon [icon]="icons.faBellConcierge"></fa-icon>
            </div>
            <div class="flex-fill text-center">
              <fa-icon [icon]="icons.faCircleQuestion"></fa-icon>
            </div>
            <div class="flex-fill text-center">
              <fa-icon [icon]="icons.faUser"></fa-icon>
            </div>
            <div class="flex-fill text-center">
              <fa-icon [icon]="icons.faArrowRightFromBracket" (click)="signOut()"></fa-icon>
            </div>
          </div>
          <div class="d-flex mb-3 mt-2">
            <div class="ms-2">
              <img src="assets/images/logo-zazz.png" class="" style="width: 24px;">
            </div>
            <div class="flex-fill ms-2 text-light">
              <p class="mb-0 mt-1" style="font-size: 12px;">Powered by ZAZZ</p>
            </div>
            <div class="ms-auto text-end text-light"><small style="font-size: 11px;"><b>v{{version}}</b></small></div>
          </div>
        </li>
      </div>
  `,
  styleUrls: []
})
export class SidebarComponent {
  @Input() user: any;
  @Input() profile: any;
  @Input() profileLogo: any;

  @ViewChild('sidebar') sidebar !: ElementRef;
  @ViewChild('dashboard') dashboard !: ElementRef;
  @ViewChild('clients') clients !: ElementRef;
  @ViewChild('tanques') tanques !: ElementRef;
  @ViewChild('tasks') tasks !: ElementRef;
  @ViewChild('reports') reports !: ElementRef;

  userLS: any = {};
  roleLS: any = {};
  permissionsLS: any = {};
  avatarLS: any = {};
  profiles: any = [];

  protected version = environment.app_version;

  isNavbarCollapsed = false;

  isCollapsed = true;
  isCollapsedA = true;
  isCollapsedM = true;
  isCollapsedP = true;
  isCollapsedF = true;
  isCollapsedI = true;

  currentRoute: string = '';
  storageService = inject(StorageService);
  statefulService = inject(StatefulService);
  constructor(
    private store: SettlementsService,
    public icons: IconsService,
    private router: Router,
    public authService: AuthService
  ) {
    this.userLS = this.storageService.getItem(STORAGE_KEYS.USER) ?? {};
    this.avatarLS = this.storageService.getItem(STORAGE_KEYS.AVATAR) ?? {};
    this.roleLS = (this.storageService.getItem(STORAGE_KEYS.ROLE) ?? {}).role;
    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url.split("/")[1];
        if (this.currentRoute == '') {
          this.currentRoute = 'dashboard';
        }

        this.sidebar?.nativeElement.querySelectorAll('.zazz-link').forEach((el: any) => {
          el.classList.remove('active');
        });
        let link: any = this.sidebar?.nativeElement.querySelector(`#${this.currentRoute}`);
        if (link) {
          link.classList.add('active');
        }
      }
    });

    this.loadProfiles();
  }

  loadProfiles() {
    this.store.getProfiles({ page: 1, per_page: 100 }).subscribe({
      next: (data: any) => {
        this.profiles = data.data;
      },
      error: (e: any) => {}
    });
  }

  changeProfile(profile: any) {
    this.profile = profile;
    let currProfile = this.profiles.find((el: any) => profile.id == el.id);
    const currentPath = this.router.url.split(/[?#]/)[0];
    const keepCalendarOpen = currentPath === '/maintenances';

    this.storageService.saveItem(STORAGE_KEYS.PROFILE, { profile: currProfile})
    this.storageService.removeItem(STORAGE_KEYS.PAYFILTERSPREFS);
    this.store.updateUser(this.user.id, { profile_id: profile.id }).subscribe({
      next: (data: any) => {
        this.storageService.saveItem(STORAGE_KEYS.USER, data);
        this.statefulService.reloadDashboard(currProfile);
        if (!keepCalendarOpen) {
          this.router.navigate(['/dashboard']);
        }
      }
    });    
  }

  navigate(e: any, collapse: string = '') {
    let link: any = e.target.closest('a');
    this.sidebar?.nativeElement.querySelectorAll('.zazz-link').forEach((el: any) => {
      el.classList.remove('active');
    });

    if (collapse) {
      if (this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.contains('collapse')) {
        this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.remove('collapse')
        this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.add('active');
      } else {
        this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.remove('active')
        this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.add('collapse');
      }
    }

    link.classList.add('active');    
  }

  signOut() {
    let redirect = this.roleLS?.group_id == 3 ? '/user/sign-in' : '/ingresar';
    this.storageService.removeItem(STORAGE_KEYS.TOKEN);
    this.storageService.removeItem(STORAGE_KEYS.USER);
    this.storageService.removeItem(STORAGE_KEYS.PROFILE);
    this.storageService.removeItem(STORAGE_KEYS.AVATAR);
    this.storageService.removeItem(STORAGE_KEYS.PERMISSIONS);
    this.storageService.removeItem(STORAGE_KEYS.ROLE);
    this.storageService.removeItem(STORAGE_KEYS.FCM_TOKEN);
    //
    window.location.href = redirect;
    // window.location.reload();
  }

  toggleNavbar() {

  }
}
